import * as React from 'react';
import PassStyle from '../passStyle/PassStyle';
import DesignerSide from './DesignerSide';
import { createUseStyles } from 'react-jss';
import { useTheme } from '../../Theme';
export const useStyles = createUseStyles({
  root: {
    position: 'absolute',
    width: ({
      theme
    }) => 320 * theme.scale,
    height: ({
      theme
    }) => 450 * theme.scale
  }
});
export default function DesignerFrontSide() {
  const theme = useTheme();
  const classes = useStyles({
    theme
  });
  return /*#__PURE__*/React.createElement(DesignerSide, null, /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(PassStyle, null)));
}
//# sourceMappingURL=DesignerFrontSide.js.map